var map = {
	"./8.jpg": 36428,
	"./FLR.jpg": 76108,
	"./fish 3.jpg": 339,
	"./flowers 01.jpg": 54159,
	"./flowers 1.jpg": 89221,
	"./flowers 2.jpg": 1370,
	"./flr 1.jpg": 48977,
	"./girl 2.jpg": 33214,
	"./girl 3.jpg": 64699,
	"./girl 4.jpg": 34696,
	"./girl with dora.jpg": 31472
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76964;